/**
 * Upload configuration settings
 */

// Maximum file size in MB for uploads
// Updated: December 11, 2025 - Reduced from 100MB to 15MB for security and reasonable limits
// Note: Nginx should be set to match (15MB) - update client_max_body_size
export const MAX_UPLOAD_SIZE_MB = parseInt(
  import.meta.env.VITE_MAX_UPLOAD_SIZE_MB || '15'
);

// Convert to bytes for validation
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

// Allowed file types for menu upload
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg'  // This covers both .jpg and .jpeg extensions
];

// File type display names
export const FILE_TYPE_NAMES: Record<string, string> = {
  'application/pdf': 'PDF',
  'image/png': 'PNG',
  'image/jpeg': 'JPEG/JPG'  // This covers both .jpg and .jpeg extensions
};

// Get allowed file extensions for display
export const ALLOWED_EXTENSIONS = '.pdf, .png, .jpg, .jpeg';